import { ReactComponent as ClosingIcon } from "../../assets/images/icon-close.svg"
import RulesImage from "../../assets/images/image-rules.svg"



const Rules = ({ isHiddin, closeModal }) => {


  const handleCloseModal = ()=>{
    closeModal(false)
  }

  return (
    isHiddin ? <>
      <div className='fixed right-0 left-0 top-0 bottom-0  modal flex justify-center items-center'>
          <div className="fixed fixed right-0 left-0 top-0 bottom-0 z-0" onClick={()=>{
            handleCloseModal()
          }}></div>
        <div className="relative px-4 w-full max-w-md z-50" >
          <div className="relative bg-white rounded-md shadow ">
            <div className="flex justify-between px-5 py-5">
              <p className='text-2xl text-darkText font-bold font-barlow'>
                RULES
              </p>
              <button
                onClick={() => {
                  handleCloseModal()
                }}>
                <ClosingIcon></ClosingIcon>
              </button>
            </div>

            <div className="flex justify-center align-center w-full">
              <div className="py-5  flex justify-center align-center "><img src={RulesImage}></img></div>
            </div>
          </div>
        </div>
      </div>
    </> : null
  )
}

export default Rules